import { get } from 'lodash-es';

import { emptyObject } from 'ui-components/default-props/empty';

export const selectFreightCommodityPresets = (state) => get(state, 'freightCommodityPresets', emptyObject);
export const selectFreightCommodityPresetsById = (state, props) => get(selectFreightCommodityPresets(state), props.id);
